angular.module("leanlaw").controller("AllocationModalController", ["$q", "$scope", "leanLawApi", "close", "params", "alerts", "userService", function ($q, $scope, leanLawApi, close, params, alerts, userService) {
  activate();
  async function activate() {
    $scope.me = await userService.me();
    $scope.loading = true;
    const {
      invoicePayment,
      payment,
      invoice
    } = params;
    try {
      if (invoicePayment) {
        $scope.allocation = await leanLawApi.getInvoicePaymentAllocation({
          id: invoicePayment.id
        });
        $scope.allocation.invoicePayments.forEach(ip => {
          ip.important = ip.invoicePayment.id === invoicePayment.id;
        });
      } else if (payment) {
        $scope.allocation = await leanLawApi.getPaymentAllocation({
          id: payment.id
        });
        $scope.allocation.invoicePayments.forEach(ip => {
          ip.important = ip.invoicePayment.payment.id === payment.id;
        });
      } else if (invoice) {
        $scope.allocation = await leanLawApi.getInvoiceAllocation({
          id: invoice.id
        });
        $scope.allocation.invoicePayments.forEach(ip => {
          ip.important = ip.invoicePayment.invoice.id === invoice.id;
        });
      } else {
        throw Error("missing payment, invoice, or invoicePayment");
      }
      $scope.json = JSON.stringify($scope.allocation, undefined, 2);
    } catch (err) {
      close(false);
      alerts.error(`Failed to load payment allocations`);
    }
    $scope.loading = false;
  }
  $scope.firmRemainder = p => Math.round(((p.data.origination.firmCredit || 0) - (p.data.origination.firmDebit || 0)) * 100) / 100;
  $scope.handleCloseButton = () => {
    close(false);
  };
}]);